import { t } from "i18next";
import Helper from "../../../core/Helper";
import ApiService from "../../../core/service/ApiService";
import { useHistory, useParams } from "react-router-dom";
import { useEffect, useState } from "react";
import { useRef } from "react";
import { Button, Card, Input, List, Select, Space, Table, Typography } from "antd";

export default function PatientBillingAddress({ patientName, patientLastname, patientCustomId }) {

    const history = useHistory();
    const { patientId } = useParams();
    const [billingAddress, setbillingAddress] = useState([]);
    const formRef = useRef();
    const [filteredData, setFilteredData] = useState([])


    const getPatientBillingAddress = async () => {
        if (!patientId) return;
        const res = await ApiService.PatientBillingAddress.GetBillingAddressList({
            patientId: patientId
        });
        if (res.success) {
            setbillingAddress(res.data)
        }
    }

    const deleteBillingAddress = async (billingAddressId) => {
        const res = await ApiService.PatientBillingAddress.DeleteBillingAddress(billingAddressId);

        if (res.success) {
            await getPatientBillingAddress();
        }
    }

    useEffect(() => {
        if (patientId) {
            getPatientBillingAddress();
        }
    }, [patientId])

    useEffect(() => {
        setFilteredData(billingAddress)
    }, [billingAddress])

    return (
        <Card>
            {<Space style={{ marginBottom: 16 }}>
                <Button size={'small'} onClick={() => {
                    history.push({
                        pathname: "/app/system/billingAddress/create",
                        state: { patientName, patientLastname, patientCustomId, patientId }
                    })
                }} type={'primary'}>{t('New')}</Button>
            </Space>}
            <Table
                size={'small'}
                dataSource={filteredData}
                pagination={false}
                columns={[
                    { dataIndex: 'id', key: 'id', title: t('Id') },
                    { dataIndex: 'billingAddressTypeName', key: 'billingAddressTypeName', title: t('Type') },
                    { dataIndex: 'billingAddressName', key: 'billingAddressName', title: t('Billing Address Name') },
                    {
                        dataIndex: '#', key: '#', title: t('#'), render: (text, row) => (
                            <Space>
                                <a key="edit" onClick={() =>
                                    history.push({
                                        pathname: "/app/system/billingAddress/edit",
                                        search: `?billingAddressId=${row.id}`,
                                        state: { patientName, patientLastname, patientCustomId, patientId }
                                    })
                                }>{t('edit')}</a>
                                <a key="delete" onClick={async () => { await deleteBillingAddress(row.id) }} style={{ color: 'red' }}>{t('Delete')}</a>
                            </Space>
                        )
                    },
                ]}
            />
        </Card>
    )
}